(function () {
  'use strict';

  function initToggle(matrix, toggle, toggleLabel) {
    if (!matrix || !toggle) return;

    var expandLabel = matrix.getAttribute('data-expand-label') || (toggleLabel ? toggleLabel.textContent : '');
    var collapseLabel = matrix.getAttribute('data-collapse-label') || expandLabel;

    toggle.addEventListener('click', function () {
      var isExpanded = matrix.getAttribute('data-expanded') === 'true';
      matrix.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      if (toggleLabel) {
        toggleLabel.textContent = isExpanded ? expandLabel : collapseLabel;
      }
    });
  }

  function initMatrix(section) {
    initToggle(
      section.querySelector('[data-tg-pm]'),
      section.querySelector('[data-tg-pm-toggle]'),
      section.querySelector('[data-tg-pm-toggle-label]')
    );
    initToggle(
      section.querySelector('[data-tg-pmi]'),
      section.querySelector('[data-tg-pmi-toggle]'),
      section.querySelector('[data-tg-pmi-toggle-label]')
    );
  }

  function initAll() {
    document.querySelectorAll('.section-labelm-product-matrix').forEach(initMatrix);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-tg-pm], [data-tg-pmi]')) {
      initMatrix(event.target);
    }
  });
})();
